export default "__VITE_ASSET__B2$3ke79__"